import { render, staticRenderFns } from "./FinanceDocuments.vue?vue&type=template&id=216ccf5d"
import script from "./FinanceDocuments.vue?vue&type=script&lang=ts"
export * from "./FinanceDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports